import React, {useEffect, useState} from 'react';
import {Button, Table} from 'antd';
import moment from 'moment';
import CustomerService from "../../../services/ewallet_integration/customer.service";
import serviceHelper from "../../../helpers/functions/service.helper";
import {Link} from "react-router-dom";

const ActivityTable = ({ filter, }) => {
    const [state, setState] = useState({
        loading : false,
        // documents : [],
        rows : [],

        // refresh
        refresh : 0,

        // pagination
        page : 1,
        display_size : 10,
        count : null,
    });

    const columns = [
        {
            title: 'Customer',
            dataIndex: 'transaction_type_code',
            key: 'to_customer_name',
            render: (type, record) => {
                const phoneFieldMap = {
                    PAYMENT: 'from_customer_phone',
                    REFUND: 'to_customer_phone',
                    TOPUP: 'to_customer_phone',
                    REDEMPTION: 'to_customer_phone'
                };

                const nameFieldMap = {
                    PAYMENT: 'from_customer_name',
                    REFUND: 'to_customer_name',
                    TOPUP: 'to_customer_name',
                    REDEMPTION: 'to_customer_name'
                };

                const phone = record[phoneFieldMap[type]] || "-";
                const name = record[nameFieldMap[type]];

                return (
                    <div>
                        <div style={{ fontWeight: 500 }}>{phone}</div>
                        {name && <div style={{ color: '#888', fontSize: '12px' }}>{name}</div>}
                    </div>
                );
            }
        },
        {
            title: "Merchant",
            dataIndex: "transaction_type_code",
            key: "merchant_name",
            render: (type, record) => {
                const merchantFieldMap = {
                    REFUND: 'from_merchant_name',
                    PAYMENT: 'to_merchant_name',
                    SETTLEMENT: 'from_merchant_name',
                };
                return record[merchantFieldMap[type]] || "-";
            }
        },
        {
            title: "Type",
            dataIndex: "transaction_type_name",
            key: "transaction_type_name",
        },
        {
            title: "Transaction No.",
            dataIndex: "transaction_no",
            key: "transaction_no"
        },
        {
            title: "Melon",
            dataIndex: "melon_amount",
            key: "melon_amount",
            align: 'right',
            render: (value, record) => {
                const melon = value || value || 0;
                return Number(melon).toFixed(2);
            }
        },
        {
            title: "Date",
            dataIndex: "created_at",
            key: "created_at",
            render: (created_at) =>
                <span>{moment(created_at).format("YYYY-MM-DD hh:mm:ssa")}</span>
        },
        {
            title: 'Action',
            dateIndex: "activity_id",
            key: 'activity_id',
            render: (v, r) => {
              return (
                  <>
                      <Link to={`/activities/detail/${v.activity_id}`}>
                          <Button>
                              View
                          </Button>
                      </Link>
                  </>
              );
            }
        }
    ];


    const paginateChange = (key, value) => {
        // set state
        setState(state => ({...state, [key] : value}));

        let generate_filter = filter;
        generate_filter[key] = value;
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    }

    const fetchReport = async () => {
        setState(state => ({...state, loading : true, }));
        const { customer_ids, search,transaction_types, start_date, end_date } = filter;
        const response = await CustomerService?.activity_listings({
            // filter
            search,
            customer_ids,
            transaction_types,
            start_date,
            end_date,

            // pagination
            page : state?.page,
            size : state?.display_size,

            // order
            order : "created_at",
            order_position : 'DESC',
        });
        const {  rows, count } = response?.data?.activity_listings;

        setState(state => ({...state, loading : false, rows : rows, count: count}));
    }

    useEffect(() => {
        fetchReport();
    }, [filter,state?.page])

    return (
        <>
            <Table
                rowKey="activity_id"
                scroll={{ x : 400, }}
                size='small'
                loading={state.loading}
                pagination={{
                    pageSize : state?.display_size,
                    current : (state?.count > state?.display_size) ? state?.page : 1,
                    total : state?.count,
                    showSizeChanger: false,
                    onChange : (page) => paginateChange('page', page)
                }}
                className='hub-table bordered'
                dataSource={state?.rows}
                columns={columns}

            />
        </>
    );
}

export default ActivityTable;